export default __webpack_public_path__ + "static/media/loginback.ee6987b1.jpg";